const flatten = require('flat');

const frLang = flatten({
  notFound: 'Page not found',
  goToHomePage: "Retour à la page d'acceuil",
  title: 'Linkpick',
  home: {
    name: 'Linkpick',
    products: 'Produits',
    price: 'Tarifs',
    aPropos: 'À propos',
    connect: 'Je me connecte',
    inscrit: "Je m'inscris",
  },
  chooseProfil: {
    title: 'Choisissez votre type de compte',
    choiceOne: "En recherche d'emploi",
    choiceTwo: 'Entreprise',
    choiceThree: 'Etablissement de formation',
    confirm: 'Cliquer pour confirmer',
  },
  signUp: {
    title: 'Inscrivez-vous avec un tiers compte',
    google: "S'inscrire avec Google",
    apple: "S'inscrire avec Apple",
    facebook: "S'inscrire avec Facebook",
    session: 'Garder ma session ouverte sur cet appareil',
    confirm: 'Créer un compte',
    without: 'ou',
    politique:
      "En créant un compte, vous acceptez les <span>conditions d'utilisation</span>, " +
      'la <span>politique relative aux cookies</span> et la <span>politique de confidentialité de Linkpick</span>. ' +
      'Vous consentez à recevoir des communications marketing de la part de Linkpick.' +
      'Vous pouvez vous en désinscrire en cliquant sur le lien contenu dans ces messages ' +
      "ou en suivant la procédure indiquée dans nos conditions d'utilisation.",
  },
  confirmSignUp: {
    title: 'Complétez la derniére étape',
    subTitle: "nécessaire pour l'inscription",
    form: {
      adressePostale: 'Adresse postale',
      codePostale: 'Code postale',
      telephone: 'Numéro de téléphone',
      siren: 'Numéro de Siren',
      cni: "Carte d'identité (pdf.png.jpeg)",
      mode: 'Vous venez pprincipalement pour:',
      confirm: 'Confirmer votre inscription',
    },
  },
  confirmSignUpParticular: {
    title: 'Complétez la derniére étape',
    optionnel: 'optionnel',
    subTitle: '(nécessaire pour obtenir un profil vérifié)',
    form: {
      adressePostale: 'Adresse postale',
      codePostale: 'Code postale',
      telephone: 'Numéro de téléphone',
      siren: 'Numéro de Siren',
      cni: "Carte d'identité (pdf.png.jpeg)",
      photoVisage: 'Photo de votre visage (pdf.png.jpeg)',
      mode: 'Vous venez pprincipalement pour:',
      confirm: 'Confirmer votre inscription',
    },
  },
  school: {
    dashboard: {
      title: 'Tableau de bord',
      subTitle: 'Synthèse de votre compte',
      etudiants: {
        title: 'Étudiants',
        entreprise: 'En entreprise(s)',
        totalEtudiant: "Total d'étudiant(s)",
        envoye: 'Contrat à envoyer',
        attente: 'Contrat en attente de signature',
      },
      affiliations: {
        title: 'Affiliastions',
        attente: 'Affiliation(s) en attente(s)',
        complete: 'Affiliation(s) complétés',
      },
      formationsCandidats: {
        title: 'Formations & Candidats',
        ouverte: 'Formation(s) ouverte(s)',
        candidat: 'Total de candidat(s)',
      },
      partenaires: {
        title: 'Partenaires',
        nombre: 'Nombre de partenaire(s)',
        emploi: "Offre(s) d'emploi(s)",
      },
      message: {
        entreprise: "Vos messages d'entreprises",
        entrepriseVide: "Vous n'avez aucun message d'entreprises",
        etudiant: "Vos messages d'étudiants",
        etudiantVide: "Vous n'avez aucun message de vos étudiants",
      },
    },
  },
  sidebar: {
    bonjour: 'Bonjour',
    parametre: 'Paramètres',
    logout: 'Se déconnecter',
  },
  student: {
    dashboard: {
      title: 'Tableau de bord',
      subTitle: 'Synthèse de votre compte',
      school: {
        title: 'Mon établissement scolaire',
        link: {
          doc: 'Transmettre un document',
          contact: 'Contacter',
          contract: 'Voir le contrat',
          absence: 'Déclarer une absence',
        },
        formation: {
          title: 'Votre formation',
        },
      },
      business: {
        title: 'Mon entreprise',
        link: {
          doc: 'Transmettre un document',
          contact: 'Contacter',
          contract: 'Voir le contrat',
          absence: 'Déclarer une absence',
        },
        formation: {
          title: 'Votre expérience',
        },
      },
    },
  },
});

export default frLang;
